module.exports = __webpack_public_path__ + "static/media/sala-doble-altura.285a85b2.jpg";